import React, { useEffect, useState } from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import { AccordionDetails } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import tableReducer from "./redux/slice/TableSile";
import { commonReducerSelector, userSelector } from "./redux/selector";
import { maChucNang, moduleCode } from "./constants/constant";
import NumbersIcon from "@mui/icons-material/Numbers";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { Scrollbars } from "react-custom-scrollbars-2";
import MuiAccordionSummary from "@mui/material/AccordionSummary";
import { styled } from "@mui/material/styles";
import ArrowForwardIosSharpIcon from "@mui/icons-material/ArrowForwardIosSharp";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import Helper from "./helpers";
import { isEmpty } from "lodash";
import home from "./assets/images/home.svg";
import capPhep from "./assets/images/capPhep.png";
import doiTuong from "./assets/images/factory.png";
import danhmuc from "./assets/images/DanhMuc.png";
import inspection from "./assets/images/inspection.png";
import nopphi from "./assets/images/payment.png";
import biendoikh from "./assets/images/global-warming.png";
import khituongthuyvan from "./assets/images/hydrometeorological.png";
import giaypheptonghop from "./assets/images/licensing.png";
import dadangsinhhoc from "./assets/images/biodiversity.png";
import quantracmt from "./assets/images/data.png";
import bando from "./assets/images/banDo.png";
import traCuuThongTin from "./assets/images/traCuuThongTin.png";
import cauHinh from "./assets/images/settings.png";
import baoCaoThongKe from "./assets/images/baoCaoThongKe.png";
import sanPham from "./assets/images/sanPham.png";
import doanhNghiep from "./assets/images/doanhNghiep.png";
import vungSanXuat from "./assets/images/vungSanXuat.png";
import loHang from "./assets/images/loHang.png";
import lichSuSanXuat from "./assets/images/lichSuSanXuat.png";
import tichHopChiaSe from "./assets/images/tichHopChiaSe.png";
import sanXuat from "./assets/images/sanXuat.png";
import cheBien from "./assets/images/cheBien.png";
import phanPhoi from "./assets/images/phanPhoi.png";
import "./styles/sidebar.scss";
import {
  Book,
  Business,
  DescriptionOutlined,
  FactoryOutlined,
  ManageHistory
} from "@mui/icons-material";
import { da } from "date-fns/locale";

export const datasidebar = {
  TC: {
    className: "trangchu",
    path: "trangchu",
    icon: <img src={home} />,
    name: "Trang chủ"
  },
  DanhMuc: {
    className: "danhmuc",
    path: "danhmuc",
    icon: <img src={giaypheptonghop} style={{ width: 23, height: 23 }} />,
    name: "Danh mục"
  },
  BanDo: {
    className: "bando",
    path: "bando",
    icon: <img src={bando} style={{ width: 23, height: 23 }} />,
    name: "Bản đồ"
  },
  QuanTriHeThong: {
    className: "quantrihethong",
    moduleCode: "quan_tri_he_thong",
    icon: <img src={cauHinh} style={{ width: 23, height: 23 }} />,
    name: "Quản trị hệ thống",
    QuanLyNguoiDung: {
      maChucNang: "quan_tri_he_thong_Quan_ly_nguoi_dung",
      className: "quan_tri_he_thong_Quan_ly_nguoi_dung",
      path: "quantrihethong/quanlynguoidung",
      name: "Quản lý người dùng"
    },
    QuanLyNhomNguoiDung: {
      maChucNang: "quan_tri_he_thong_Quan_ly_nhom_nguoi_dung",
      className: "quan_tri_he_thong_Quan_ly_nhom_nguoi_dung",
      path: "quantrihethong/quanlynhomnguoidung",
      name: "Quản lý nhóm người dùng"
    },
    QuanLyNhomChucNang: {
      maChucNang: "quan_tri_he_thong_Quan_ly_nhom_chuc_nang",
      className: "quan_tri_he_thong_Quan_ly_nhom_chuc_nang",
      path: "quantrihethong/quanlynhomchucnang",
      name: "Quản lý nhóm chức năng"
    },
    QuanLyChucNang: {
      maChucNang: "quan_tri_he_thong_Quan_ly_chuc_nang",
      className: "quan_tri_he_thong_Quan_ly_chuc_nang",
      path: "quantrihethong/quanlychucnang",
      name: "Quản lý chức năng"
    },
    CauHinhHienThiSanPham: {
      maChucNang: "quan_tri_he_thong_Cau_hinh_hien_thi_san_pham",
      className: "quan_tri_he_thong_Cau_hinh_hien_thi_san_pham",
      path: "quantrihethong/cauhinhhienthithongtintruyxuat",
      name: "Cấu hình hiển thị TT truy xuất"
    },
    QuanLySlide: {
      maChucNang: "quan_tri_he_thong_Quan_ly_slide",
      className: "quan_tri_he_thong_Quan_ly_slide",
      path: "quantrihethong/quanlyslide",
      name: "Quản lý slide hiển thị"
    },
    PhanQuyenChucNang: {
      maChucNang: "quan_tri_he_thong_Phan_quyen_chuc_nang",
      className: "quan_tri_he_thong_Phan_quyen_chuc_nang",
      path: "quantrihethong/phanquyenchucnang",
      name: "Phân quyền chức năng"
    },
    QuanLyTinTuc: {
      maChucNang: "quan_tri_he_thong_Quan_ly_tin_tuc",
      className: "quan_tri_he_thong_Quan_ly_tin_tuc",
      path: "quantrihethong/quanlytintuc",
      name: "Quản lý tin tức"
    }
  },
  ThongTinSanXuat: {
    className: "thongtinsanxuat",
    moduleCode: "thong_tin_san_xuat",
    icon: <img src={doiTuong} style={{ width: 23, height: 23 }} />,
    name: "Thông tin sản xuất",
    CoSoPhanPhoi: {
      maChucNang: "thong_tin_san_xuat_Co_so_phan_phoi",
      className: "thong_tin_san_xuat_Co_so_phan_phoi",
      path: "thongtinsanxuat/cosophanphoi",
      name: "Cơ sở phân phối"
    },
    CoSoSanXuat: {
      maChucNang: "thong_tin_san_xuat_Co_so_san_xuat",
      className: "thong_tin_san_xuat_Co_so_san_xuat",
      path: "thongtinsanxuat/cososanxuat",
      name: "Cơ sở sản xuất"
    },
    CoSoCheBien: {
      maChucNang: "thong_tin_san_xuat_Co_so_che_bien",
      className: "thong_tin_san_xuat_Co_so_che_bien",
      path: "thongtinsanxuat/cosochebien",
      name: "Cơ sở chế biến"
    }
  },
  SanPham: {
    className: "sanpham",
    path: "sanpham",
    icon: <img src={sanPham} style={{ width: 23, height: 23 }} />,
    name: "Sản phẩm"
  },
  ThongTinDoanhNghiep: {
    className: "thongtindoanhnghiep",
    path: "thongtindoanhnghiep",
    icon: <img src={doanhNghiep} style={{ width: 23, height: 23 }} />,
    name: "Thông tin doanh nghiệp"
  },
  LoHang: {
    className: "lohang",
    path: "lohang",
    icon: <img src={loHang} style={{ width: 23, height: 23 }} />,
    name: "Lô hàng"
  },
  LichSuSanXuat: {
    className: "lichsusanxuat",
    path: "lichsusanxuat",
    icon: <img src={lichSuSanXuat} style={{ width: 23, height: 23 }} />,
    name: "Lịch sử sản xuất"
  },
  ThongTinLichSuSanXuat: {
    className: "thongtinlichsusanxuat",
    path: "thongtinlichsusanxuat",
    icon: <img src={sanXuat} style={{ width: 23, height: 23 }} />,
    name: "Lịch sử thông tin sản xuất"
  },
  ThongTinLichSuCheBien: {
    className: "thongtinlichsuchebien",
    path: "thongtinlichsuchebien",
    icon: <img src={cheBien} style={{ width: 23, height: 23 }} />,
    name: "Lịch sử thông tin chế biến"
  },
  ThongTinLichSuPhanPhoi: {
    className: "thongtinlichsuphanphoi",
    path: "thongtinlichsuphanphoi",
    icon: <img src={phanPhoi} style={{ width: 23, height: 23 }} />,
    name: "Lịch sử thông tin phân phối"
  },
  VungTrong: {
    className: "vungsanxuat",
    path: "vungsanxuat",
    icon: <img src={vungSanXuat} style={{ width: 23, height: 23 }} />,
    name: "Vùng sản xuất"
  },
  BaoCaoThongKe: {
    className: "baocaothongke",
    moduleCode: "bao_cao_thong_ke",
    icon: <img src={baoCaoThongKe} style={{ width: 23, height: 23 }} />,
    name: "Báo cáo thống kê",
    DuLieuThongKe: {
      maChucNang: "bao_cao_thong_ke_Du_lieu_thong_ke",
      className: "bao_cao_thong_ke_Du_lieu_thong_ke",
      path: "baocaothongke/dulieuthongke",
      name: "Dữ liệu thống kê"
    },
    DuLieuKhiHau: {
      maChucNang: "bao_cao_thong_ke_Du_lieu_khi_hau",
      className: "bao_cao_thong_ke_Du_lieu_khi_hau",
      path: "baocaothongke/dulieukhihau",
      name: "Dữ liệu khí hậu"
    },
    BaoCaoChuyenDe: {
      maChucNang: "bao_cao_thong_ke_Bao_cao_chuyen_de",
      className: "bao_cao_thong_ke_Bao_cao_chuyen_de",
      path: "baocaothongke/baocaochuyende",
      name: "Báo cáo chuyên đề"
    }
  },
  NhatKyHeThong: {
    className: "nhatkyhethong",
    path: "nhat-ky-he-thong",
    icon: <ManageHistory />,
    name: "Nhật ký hệ thống"
  }
};

function ActiveClassAndRole({
  setExpanded,
  commonReducer,
  setPhanQuyen,
  link
}) {
  const activeClass = (value, classNameIcon) => {
    if (document.querySelector(`#active`)) {
      const a = document.querySelector(`#active`);
      a.setAttribute("id", "");
    }
    if (document.querySelector(`.${value}`)) {
      const box = document.querySelector(`.${value}`);
      box.setAttribute("id", "active");
    }
    if (document.querySelector(`#activeColorIcon`)) {
      const icd = document.querySelector(`#activeColorIcon`);
      icd.setAttribute("id", "");
    }
    if (document.querySelector(`.${classNameIcon}`)) {
      const ic = document.querySelector(`.${classNameIcon}`);
      ic.setAttribute("id", "activeColorIcon");
    }
    setPhanQuyen(true);
  };
  if (!link) {
    setPhanQuyen(true);
    return;
  }
  if (
    link.indexOf(`/trangchu`) !== -1 &&
    Helper.handleGetEditableFunction(
      commonReducer.functions.data,
      maChucNang.TC
    )
  ) {
    activeClass(datasidebar.TC.className);
    return;
  }
  if (link.indexOf(`/danhmuc`) !== -1) {
    activeClass(datasidebar.DanhMuc.className);
    return;
  }

  // QUẢN TRỊ HỆ THỐNG
  // Quản lý người dùng
  if (
    link.indexOf(`/${datasidebar.QuanTriHeThong.QuanLyNguoiDung.path}`) !== -1
  ) {
    setExpanded(datasidebar.QuanTriHeThong.className);
    activeClass(datasidebar.QuanTriHeThong.QuanLyNguoiDung.className);
    return;
  }
  if (
    link.indexOf(`/${datasidebar.QuanTriHeThong.QuanLyNhomNguoiDung.path}`) !== -1
  ) {
    setExpanded(datasidebar.QuanTriHeThong.className);
    activeClass(datasidebar.QuanTriHeThong.QuanLyNhomNguoiDung.className);
    return;
  }
  if (
    link.indexOf(`/${datasidebar.QuanTriHeThong.QuanLyNhomChucNang.path}`) !== -1
  ) {
    setExpanded(datasidebar.QuanTriHeThong.className);
    activeClass(datasidebar.QuanTriHeThong.QuanLyNhomChucNang.className);
    return;
  }
  if (
    link.indexOf(`/${datasidebar.QuanTriHeThong.QuanLyChucNang.path}`) !== -1
  ) {
    setExpanded(datasidebar.QuanTriHeThong.className);
    activeClass(datasidebar.QuanTriHeThong.QuanLyChucNang.className);
    return;
  }
  // Cấu hình hiển thị sản phẩm
  if (
    link.indexOf(
      `/${datasidebar.QuanTriHeThong.CauHinhHienThiSanPham.path}`
    ) !== -1
  ) {
    setExpanded(datasidebar.QuanTriHeThong.className);
    activeClass(datasidebar.QuanTriHeThong.CauHinhHienThiSanPham.className);
    return;
  }

  if (link.indexOf(`/${datasidebar.QuanTriHeThong.QuanLySlide.path}`) !== -1) {
    setExpanded(datasidebar.QuanTriHeThong.className);
    activeClass(datasidebar.QuanTriHeThong.QuanLySlide.className);
    return;
  }

  if (link.indexOf(`/${datasidebar.QuanTriHeThong.QuanLyTinTuc.path}`) !== -1) {
    setExpanded(datasidebar.QuanTriHeThong.className);
    activeClass(datasidebar.QuanTriHeThong.QuanLyTinTuc.className);
    return;
  }

  if (link.indexOf(`/${datasidebar.QuanTriHeThong.PhanQuyenChucNang.path}`) !== -1) {
    setExpanded(datasidebar.QuanTriHeThong.className);
    activeClass(datasidebar.QuanTriHeThong.PhanQuyenChucNang.className);
    return;
  }

  // THÔNG TIN SẢN XUẤT
  // Cơ sở phân phối
  if (
    link.indexOf(`/${datasidebar.ThongTinSanXuat.CoSoPhanPhoi.path}`) !== -1
  ) {
    setExpanded(datasidebar.ThongTinSanXuat.className);
    activeClass(datasidebar.ThongTinSanXuat.CoSoPhanPhoi.className);
    return;
  }
  // Cơ sở sản xuất
  if (link.indexOf(`/${datasidebar.ThongTinSanXuat.CoSoSanXuat.path}`) !== -1) {
    setExpanded(datasidebar.ThongTinSanXuat.className);
    activeClass(datasidebar.ThongTinSanXuat.CoSoSanXuat.className);
    return;
  }

  // Cơ sở chế biến
  if (link.indexOf(`/${datasidebar.ThongTinSanXuat.CoSoCheBien.path}`) !== -1) {
    setExpanded(datasidebar.ThongTinSanXuat.className);
    activeClass(datasidebar.ThongTinSanXuat.CoSoCheBien.className);
    return;
  }

  // BÁO CÁO THỐNG KÊ
  // Dữ liệu thống kê
  if (link.indexOf(`/${datasidebar.BaoCaoThongKe.DuLieuThongKe.path}`) !== -1) {
    setExpanded(datasidebar.BaoCaoThongKe.className);
    activeClass(datasidebar.BaoCaoThongKe.DuLieuThongKe.className);
    return;
  }
  // Dữ liệu khí hậu
  if (link.indexOf(`/${datasidebar.BaoCaoThongKe.DuLieuKhiHau.path}`) !== -1) {
    setExpanded(datasidebar.BaoCaoThongKe.className);
    activeClass(datasidebar.BaoCaoThongKe.DuLieuKhiHau.className);
    return;
  }
  // Báo cáo chuyên đề
  if (
    link.indexOf(`/${datasidebar.BaoCaoThongKe.BaoCaoChuyenDe.path}`) !== -1
  ) {
    setExpanded(datasidebar.BaoCaoThongKe.className);
    activeClass(datasidebar.BaoCaoThongKe.BaoCaoChuyenDe.className);
    return;
  }

  // Bản đồ
  if (
    link.indexOf(`/bando`) !== -1 &&
    Helper.handleGetEditableFunction(
      commonReducer.functions.data,
      maChucNang.BANDO
    )
  ) {
    activeClass(datasidebar.BanDo.className);
    return;
  }

  //Sản phẩm
  if (
    link.indexOf(`/sanpham`) !== -1 &&
    Helper.handleGetEditableFunction(
      commonReducer.functions.data,
      maChucNang.SANPHAM
    )
  ) {
    activeClass(datasidebar.SanPham.className);
    return;
  }

  //Thông tin doanh nghiệp
  if (
    link.indexOf(`/${datasidebar.ThongTinDoanhNghiep.path}`) !== -1 &&
    Helper.handleGetEditableFunction(
      commonReducer.functions.data,
      maChucNang.THONGTINDOANHNGHIEP
    )
  ) {
    activeClass(datasidebar.ThongTinDoanhNghiep.className);
    return;
  }
  //Lô hàng
  if (
    link.indexOf(`/${datasidebar.LoHang.path}`) !== -1 &&
    Helper.handleGetEditableFunction(
      commonReducer.functions.data,
      maChucNang.LOHANG
    )
  ) {
    activeClass(datasidebar.LoHang.className);
    return;
  }
  //Lịch sử sản xuất
  if (
    link.indexOf(`/${datasidebar.LichSuSanXuat.path}`) !== -1 &&
    Helper.handleGetEditableFunction(
      commonReducer.functions.data,
      maChucNang.LICHSUSANXUAT
    )
  ) {
    activeClass(datasidebar.LichSuSanXuat.className);
    return;
  }
  //Thông tin lịch sử sản xuất
  if (
    link.indexOf(`/${datasidebar.ThongTinLichSuSanXuat.path}`) !== -1 &&
    Helper.handleGetEditableFunction(
      commonReducer.functions.data,
      maChucNang.THONGTINLICHSUSANXUAT
    )
  ) {
    activeClass(datasidebar.ThongTinLichSuSanXuat.className);
    return;
  }
  //Thông tin lịch sử chế biến
  if (
    link.indexOf(`/${datasidebar.ThongTinLichSuCheBien.path}`) !== -1 &&
    Helper.handleGetEditableFunction(
      commonReducer.functions.data,
      maChucNang.THONGTINLICHSUCHEBIEN
    )
  ) {
    activeClass(datasidebar.ThongTinLichSuCheBien.className);
    return;
  }
  //Thông tin lịch sử phân phối
  if (
    link.indexOf(`/${datasidebar.ThongTinLichSuPhanPhoi.path}`) !== -1 &&
    Helper.handleGetEditableFunction(
      commonReducer.functions.data,
      maChucNang.THONGTINLICHSUPHANPHOI
    )
  ) {
    activeClass(datasidebar.ThongTinLichSuPhanPhoi.className);
    return;
  }
  //Vùng trồng
  if (
    link.indexOf(`/${datasidebar.VungTrong.path}`) !== -1 &&
    Helper.handleGetEditableFunction(
      commonReducer.functions.data,
      maChucNang.VUNGTRONG
    )
  ) {
    activeClass(datasidebar.VungTrong.className);
    return;
  }

  if (link.indexOf(`/${datasidebar.NhatKyHeThong.path}`) !== -1) {
    activeClass(datasidebar.NhatKyHeThong.className);
    return;
  }

  // setPhanQuyen(false);
}

const AccordionSummarytest = styled(props => (
  <MuiAccordionSummary
    expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: "0.9rem" }} />}
    {...props}
  />
))(({ theme }) => ({
  backgroundColor:
    theme.palette.mode === "dark"
      ? "rgba(255, 255, 255, .05)"
      : "rgba(0, 0, 0, .03)",
  flexDirection: "row-reverse",
  "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
    transform: "rotate(90deg)"
  }
}));

const BootstrapTooltip = styled(({ className, ...props }) => (
  <Tooltip
    {...props}
    placement="right"
    arrow
    classes={{ popper: className }}
    leaveDelay={200}
  />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: "#132639"
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#132639",
    maxWidth: 500
  }
}));

function MenuCap1(props) {
  return (
    <AccordionSummary
      style={{
        paddingLeft: props.openDraw === 1 ? 5 : 2,
        paddingRight: props.openDraw === 1 ? 20 : 0
      }}
      className={props.className}
      expandIcon={
        props.expandIcon &&
        props.openDraw === 1 && <KeyboardArrowRightIcon fontSize="small" />
      }
      onClick={props.onClick && props.onClick}
    >
      {props.openDraw === 1 ? (
        <div
          className="my-sidebar__menu__icon"
          style={{ width: 35, textAlign: "center" }}
        >
          {props.icon && props.icon}
        </div>
      ) : (
        <BootstrapTooltip
          title={TitleTooltip(
            props.ten,
            props.onClickToolTip,
            props?.groupFunctions
          )}
        >
          <div
            className="my-sidebar__menu__icon"
            style={{ width: 35, textAlign: "center" }}
          >
            {props.icon && props.icon}
          </div>
        </BootstrapTooltip>
      )}
      {props.openDraw === 1 && (
        <p
          className="my-sidebar__menu__title"
          style={{ opacity: props.openDraw }}
        >
          {props.ten}
        </p>
      )}
    </AccordionSummary>
  );
}

function MenuCap2(props) {
  return (
    <AccordionSummarytest
      sx
      className={props.className}
      expandIcon={
        props.expandIcon && <KeyboardArrowRightIcon fontSize="small" />
      }
      onClick={props.onClick && props.onClick}
    >
      <div style={{ opacity: props.openDraw }}>{props.icon && props.icon}</div>
      <p
        className="my-sidebar__menu__title__expand"
        style={{
          opacity: props.openDraw,
          paddingLeft: props.expandIcon ? "2px" : "22px"
        }}
      >
        <ChevronRightIcon style={{ fontSize: "medium" }} />
        {props.ten}
      </p>
    </AccordionSummarytest>
  );
}

function TitleTooltip(name, onClick, groupFunctions) {
  switch (name) {
    case datasidebar.TC.name:
      return getTrangChu(onClick);
    case datasidebar.DanhMuc.name:
      return getDanhMuc(onClick);
    case datasidebar.BanDo.name:
      return getBanDo(onClick);
    case datasidebar.SanPham.name:
      return getSanPham(onClick);
    case datasidebar.ThongTinDoanhNghiep.name:
      return getThongTinDoanhNghiep(onClick);
    case datasidebar.LoHang.name:
      return getLoHang(onClick);
    case datasidebar.LichSuSanXuat.name:
      return getLichSuSanXuat(onClick);
    case datasidebar.ThongTinLichSuSanXuat.name:
      return getThongTinLichSuSanXuat(onClick);
    case datasidebar.ThongTinLichSuCheBien.name:
      return getThongTinLichSuCheBien(onClick);
    case datasidebar.ThongTinLichSuPhanPhoi.name:
      return getThongTinLichSuPhanPhoi(onClick);
    case datasidebar.VungTrong.name:
      return getVungTrong(onClick);
    case datasidebar.QuanTriHeThong.name:
      return getQuanTriHeThong(onClick, groupFunctions);
    case datasidebar.ThongTinSanXuat.name:
      return getThongTinSanXuat(onClick, groupFunctions);
    case datasidebar.BaoCaoThongKe.name:
      return getBaoCaoThongKe(onClick, groupFunctions);

    default:
      return <div></div>;
  }
}

const getTrangChu = onClick => {
  return (
    <div
      onClick={() => {
        onClick(datasidebar.TC.className, datasidebar.TC.path);
      }}
      className="title-tooltip"
    >
      {datasidebar.TC.name}
    </div>
  );
};

const getDanhMuc = onClick => {
  return (
    <div
      onClick={() => {
        onClick(datasidebar.DanhMuc.className, datasidebar.DanhMuc.path);
      }}
      className="title-tooltip"
    >
      {datasidebar.DanhMuc.name}
    </div>
  );
};

const getQuanTriHeThong = (onClick, groupFunctions) => {
  return (
    <div>
      {groupFunctions[moduleCode.QUANTRIHETHONG].includes(
        maChucNang.QUANTRIHETHONG_QUANLYNGUOIDUNG
      ) && (
        <div
          onClick={() => {
            onClick(
              datasidebar.QuanTriHeThong.className,
              datasidebar.QuanTriHeThong.QuanLyNguoiDung.path
            );
          }}
          className="title-tooltip"
        >
          {datasidebar.QuanTriHeThong.QuanLyNguoiDung.name}
        </div>
      )}
      {groupFunctions[moduleCode.QUANTRIHETHONG].includes(
        maChucNang.QUANTRIHETHONG_QUANLYNHOMNGUOIDUNG
      ) && (
        <div
          onClick={() => {
            onClick(
              datasidebar.QuanTriHeThong.className,
              datasidebar.QuanTriHeThong.QuanLyNhomNguoiDung.path
            );
          }}
          className="title-tooltip"
        >
          {datasidebar.QuanTriHeThong.QuanLyNhomNguoiDung.name}
        </div>
      )}
      {groupFunctions[moduleCode.QUANTRIHETHONG].includes(
        maChucNang.QUANTRIHETHONG_QUANLYNHOMCHUCNANG
      ) && (
        <div
          onClick={() => {
            onClick(
              datasidebar.QuanTriHeThong.className,
              datasidebar.QuanTriHeThong.QuanLyNhomChucNang.path
            );
          }}
          className="title-tooltip"
        >
          {datasidebar.QuanTriHeThong.QuanLyNhomChucNang.name}
        </div>
      )}
      {groupFunctions[moduleCode.QUANTRIHETHONG].includes(
        maChucNang.QUANTRIHETHONG_QUANLYCHUCNANG
      ) && (
        <div
          onClick={() => {
            onClick(
              datasidebar.QuanTriHeThong.className,
              datasidebar.QuanTriHeThong.QuanLyChucNang.path
            );
          }}
          className="title-tooltip"
        >
          {datasidebar.QuanTriHeThong.QuanLyChucNang.name}
        </div>
      )}
      {groupFunctions[moduleCode.QUANTRIHETHONG].includes(
        maChucNang.QUANTRIHETHONG_CAUHINHHIENTHISANPHAM
      ) && (
        <div
          onClick={() => {
            onClick(
              datasidebar.QuanTriHeThong.className,
              datasidebar.QuanTriHeThong.CauHinhHienThiSanPham.path
            );
          }}
          className="title-tooltip"
        >
          {datasidebar.QuanTriHeThong.CauHinhHienThiSanPham.name}
        </div>
      )}
      {groupFunctions[moduleCode.QUANTRIHETHONG].includes(
        maChucNang.QUANTRIHETHONG_QUANLYSLIDE
      ) && (
        <div
          onClick={() => {
            onClick(
              datasidebar.QuanTriHeThong.className,
              datasidebar.QuanTriHeThong.QuanLySlide.path
            );
          }}
          className="title-tooltip"
        >
          {datasidebar.QuanTriHeThong.QuanLySlide.name}
        </div>
      )}
      {groupFunctions[moduleCode.QUANTRIHETHONG].includes(
        maChucNang.QUANTRIHETHONG_QUANLYTINTUC
      ) && (
        <div
          onClick={() => {
            onClick(
              datasidebar.QuanTriHeThong.className,
              datasidebar.QuanTriHeThong.QuanLyTinTuc.path
            );
          }}
          className="title-tooltip"
        >
          {datasidebar.QuanTriHeThong.QuanLyTinTuc.name}
        </div>
      )}
      {groupFunctions[moduleCode.QUANTRIHETHONG].includes(
        maChucNang.QUANTRIHETHONG_PHANQUYENCHUCNANG
      ) && (
        <div
          onClick={() => {
            onClick(
              datasidebar.QuanTriHeThong.className,
              datasidebar.QuanTriHeThong.PhanQuyenChucNang.path
            );
          }}
          className="title-tooltip"
        >
          {datasidebar.QuanTriHeThong.PhanQuyenChucNang.name}
        </div>
      )}
    </div>
  );
};

const getThongTinSanXuat = (onClick, groupFunctions) => {
  return (
    <div>
      {groupFunctions[moduleCode.THONGTINSANXUAT].includes(
        maChucNang.THONGTINSANXUAT_COSOPHANPHOI
      ) && (
        <div
          onClick={() => {
            onClick(
              datasidebar.ThongTinSanXuat.className,
              datasidebar.ThongTinSanXuat.CoSoPhanPhoi.path
            );
          }}
          className="title-tooltip"
        >
          {datasidebar.ThongTinSanXuat.CoSoPhanPhoi.name}
        </div>
      )}
      {groupFunctions[moduleCode.THONGTINSANXUAT].includes(
        maChucNang.THONGTINSANXUAT_COSOSANXUAT
      ) && (
        <div
          onClick={() => {
            onClick(
              datasidebar.ThongTinSanXuat.className,
              datasidebar.ThongTinSanXuat.CoSoSanXuat.path
            );
          }}
          className="title-tooltip"
        >
          {datasidebar.ThongTinSanXuat.CoSoSanXuat.name}
        </div>
      )}
      {groupFunctions[moduleCode.THONGTINSANXUAT].includes(
        maChucNang.THONGTINSANXUAT_COSOCHEBIEN
      ) && (
        <div
          onClick={() => {
            onClick(
              datasidebar.ThongTinSanXuat.className,
              datasidebar.ThongTinSanXuat.CoSoCheBien.path
            );
          }}
          className="title-tooltip"
        >
          {datasidebar.ThongTinSanXuat.CoSoCheBien.name}
        </div>
      )}
    </div>
  );
};

const getBaoCaoThongKe = (onClick, groupFunctions) => {
  return (
    <div>
      {groupFunctions[moduleCode.BAOCAOTHONGKE].includes(
        maChucNang.BAOCAOTHONGKE_DULIEUTHONGKE
      ) && (
        <div
          onClick={() => {
            onClick(
              datasidebar.BaoCaoThongKe.className,
              datasidebar.BaoCaoThongKe.DuLieuThongKe.path
            );
          }}
          className="title-tooltip"
        >
          {datasidebar.BaoCaoThongKe.DuLieuThongKe.name}
        </div>
      )}
      {groupFunctions[moduleCode.BAOCAOTHONGKE].includes(
        maChucNang.BAOCAOTHONGKE_DULIEUKHIHAU
      ) && (
        <div
          onClick={() => {
            onClick(
              datasidebar.BaoCaoThongKe.className,
              datasidebar.BaoCaoThongKe.DuLieuKhiHau.path
            );
          }}
          className="title-tooltip"
        >
          {datasidebar.BaoCaoThongKe.DuLieuKhiHau.name}
        </div>
      )}
      {groupFunctions[moduleCode.BAOCAOTHONGKE].includes(
        maChucNang.BAOCAOTHONGKE_BAOCAOCHUYENDE
      ) && (
        <div
          onClick={() => {
            onClick(
              datasidebar.BaoCaoThongKe.className,
              datasidebar.BaoCaoThongKe.BaoCaoChuyenDe.path
            );
          }}
          className="title-tooltip"
        >
          {datasidebar.BaoCaoThongKe.BaoCaoChuyenDe.name}
        </div>
      )}
    </div>
  );
};

const getBanDo = onClick => {
  return (
    <div
      onClick={() => {
        onClick(datasidebar.BanDo.className, datasidebar.BanDo.path);
      }}
      className="title-tooltip"
    >
      {datasidebar.BanDo.name}
    </div>
  );
};

const getSanPham = onClick => {
  return (
    <div
      onClick={() => {
        onClick(datasidebar.SanPham.className, datasidebar.SanPham.path);
      }}
      className="title-tooltip"
    >
      {datasidebar.SanPham.name}
    </div>
  );
};
const getThongTinDoanhNghiep = onClick => {
  return (
    <div
      onClick={() => {
        onClick(
          datasidebar.ThongTinDoanhNghiep.className,
          datasidebar.ThongTinDoanhNghiep.path
        );
      }}
      className="title-tooltip"
    >
      {datasidebar.ThongTinDoanhNghiep.name}
    </div>
  );
};
const getLoHang = onClick => {
  return (
    <div
      onClick={() => {
        onClick(datasidebar.LoHang.className, datasidebar.LoHang.path);
      }}
      className="title-tooltip"
    >
      {datasidebar.LoHang.name}
    </div>
  );
};
const getLichSuSanXuat = onClick => {
  return (
    <div
      onClick={() => {
        onClick(
          datasidebar.LichSuSanXuat.className,
          datasidebar.LichSuSanXuat.path
        );
      }}
      className="title-tooltip"
    >
      {datasidebar.LichSuSanXuat.name}
    </div>
  );
};
const getThongTinLichSuSanXuat = onClick => {
  return (
    <div
      onClick={() => {
        onClick(
          datasidebar.ThongTinLichSuSanXuat.className,
          datasidebar.ThongTinLichSuSanXuat.path
        );
      }}
      className="title-tooltip"
    >
      {datasidebar.ThongTinLichSuSanXuat.name}
    </div>
  );
};
const getThongTinLichSuCheBien = onClick => {
  return (
    <div
      onClick={() => {
        onClick(
          datasidebar.ThongTinLichSuCheBien.className,
          datasidebar.ThongTinLichSuCheBien.path
        );
      }}
      className="title-tooltip"
    >
      {datasidebar.ThongTinLichSuCheBien.name}
    </div>
  );
};
const getThongTinLichSuPhanPhoi = onClick => {
  return (
    <div
      onClick={() => {
        onClick(
          datasidebar.ThongTinLichSuPhanPhoi.className,
          datasidebar.ThongTinLichSuPhanPhoi.path
        );
      }}
      className="title-tooltip"
    >
      {datasidebar.ThongTinLichSuPhanPhoi.name}
    </div>
  );
};
const getVungTrong = onClick => {
  return (
    <div
      onClick={() => {
        onClick(datasidebar.VungTrong.className, datasidebar.VungTrong.path);
      }}
      className="title-tooltip"
    >
      {datasidebar.VungTrong.name}
    </div>
  );
};

export default function MySideBar(props) {
  const [openDraw, setOpenDraw] = useState(0);
  const [expanded, setExpanded] = useState(false);
  const [expandedDetail, setExpandedDetail] = useState(false);
  const commonReducer = useSelector(commonReducerSelector);
  const user = useSelector(userSelector);
  let navigate = useNavigate(); //chuyển trang
  const dispatch = useDispatch();

  useEffect(() => {
    setOpenDraw(props.openDraw ? 1 : 0);
    if (!props.openDraw) {
      setExpanded(false);
    }
  }, [props.openDraw]);

  useEffect(() => {
    if (
      localStorage.getItem("CSCORE_LINK") === "/" ||
      localStorage.getItem("CSCORE_LINK") === "" ||
      localStorage.getItem("CSCORE_LINK") === "/"
    ) {
      if (props.defaultOpen) {
        const firstValue = commonReducer?.functions?.data?.[0];
        for (let key in datasidebar) {
          if (datasidebar[key]?.moduleCode === firstValue?.moduleCode) {
            setExpanded(datasidebar[key].className);
            for (let childKey in datasidebar[key]) {
              if (
                datasidebar[key][childKey]?.maChucNang ===
                firstValue?.maChucNang
              ) {
                navigate(datasidebar[key][childKey]?.path);
                props.setPhanQuyen(true);
                if (document.querySelector(`#active`)) {
                  const a = document.querySelector(`#active`);
                  a.setAttribute("id", "");
                }
                if (
                  document.querySelector(
                    `.${datasidebar[key][childKey]?.className}`
                  )
                ) {
                  const box = document.querySelector(
                    `.${datasidebar[key][childKey]?.className}`
                  );
                  box.setAttribute("id", "active");
                }
                props.setLink(`/${datasidebar[key][childKey]?.path}`);
              }
            }
          }
        }
      } else {
        ActiveClassAndRole({
          setExpanded: setExpanded,
          setExpandedDetail: setExpandedDetail,
          commonReducer: commonReducer,
          setPhanQuyen: props.setPhanQuyen,
          link: `/${datasidebar.TC.path}`,
          check: true
        });
        props.setLink(`/${datasidebar.TC.path}`);
      }
    } else {
      ActiveClassAndRole({
        setExpanded: setExpanded,
        setExpandedDetail: setExpandedDetail,
        commonReducer: commonReducer,
        setPhanQuyen: props.setPhanQuyen,
        link: localStorage.getItem("CSCORE_LINK"),
        check: true
      });
      props.setLink(localStorage.getItem("CSCORE_LINK"));
    }
  }, [commonReducer.functions, props.defaultOpen]);

  const handleMenuCap1 = (panel, link) => (e, isExpanded) => {
    ActiveClassAndRole({
      setExpanded: setExpanded,
      setExpandedDetail: setExpandedDetail,
      commonReducer: commonReducer,
      setPhanQuyen: props.setPhanQuyen,
      link: `/${link}`
    });
    props.setLink(`/${link}`);
    setExpanded(isExpanded ? panel : false);
    setExpandedDetail(false);
    if (document.querySelector(`#active`)) {
      const a = document.querySelector(`#active`);
      a.setAttribute("id", "");
    }
    if (document.querySelector(`#active1`)) {
      const a = document.querySelector(`#active1`);
      a.setAttribute("id", "");
    }
    const box = document.querySelector(`.${panel}`);
    box.setAttribute("id", "active");
    dispatch(tableReducer.actions.offdetail());
    dispatch(tableReducer.actions.closefullsize());
    navigate(link);
  };

  const handleMenuExpandCap1 = (panel, link) => (e, isExpanded) => {
    if (openDraw === 1) {
      setExpanded(isExpanded ? panel : false);
      setExpandedDetail(false);
      if (expanded === panel) {
        ActiveClassAndRole({
          setExpanded: () => {},
          setExpandedDetail: setExpandedDetail,
          commonReducer: commonReducer,
          setPhanQuyen: props.setPhanQuyen,
          link: link ? `/${link}` : undefined
        });
      }
    }
  };

  const handleMenuDetailCap2 = (classname, link, parent) => () => {
    ActiveClassAndRole({
      setExpanded: setExpanded,
      setExpandedDetail: setExpandedDetail,
      commonReducer: commonReducer,
      setPhanQuyen: props.setPhanQuyen,
      link: `/${link}`
    });
    props.setLink(`/${link}`);
    if (document.querySelector(`#active`)) {
      const a = document.querySelector(`#active`);
      a.setAttribute("id", "");
    }
    if (document.querySelector(`#active1`)) {
      const a = document.querySelector(`#active1`);
      a.setAttribute("id", "");
    }
    const box = document.querySelector(`.${classname}`);
    const box1 = document.querySelector(`.${parent}`);
    box1.setAttribute("id", "active1");
    box.setAttribute("id", "active");
    dispatch(tableReducer.actions.offdetail());
    dispatch(tableReducer.actions.closefullsize());
    navigate(link);
    setExpandedDetail(false);
  };

  const handleMenuCap1_ToolTip = (panel, link) => (e, isExpanded) => {
    ActiveClassAndRole({
      setExpanded: () => {},
      setExpandedDetail: setExpandedDetail,
      commonReducer: commonReducer,
      setPhanQuyen: props.setPhanQuyen,
      link: `/${link}`
    });
    props.setLink(`/${link}`);
    setExpanded(false);
    setExpandedDetail(false);
    if (document.querySelector(`#active`)) {
      const a = document.querySelector(`#active`);
      a.setAttribute("id", "");
    }
    const box = document.querySelector(`.${panel}`);
    box.setAttribute("id", "active");
    dispatch(tableReducer.actions.offdetail());
    dispatch(tableReducer.actions.closefullsize());
    navigate(link);
  };
  const handleMenuCap2_ToolTip = (panel, link) => {
    ActiveClassAndRole({
      setExpanded: () => {},
      setExpandedDetail: setExpandedDetail,
      commonReducer: commonReducer,
      setPhanQuyen: props.setPhanQuyen,
      link: `/${link}`
    });
    props.setLink(`/${link}`);
    setExpanded(false);
    setExpandedDetail(false);
    if (document.querySelector(`#active`)) {
      const a = document.querySelector(`#active`);
      a.setAttribute("id", "");
    }
    const box = document.querySelector(`.${panel}`);
    box.setAttribute("id", "active");
    dispatch(tableReducer.actions.offdetail());
    dispatch(tableReducer.actions.closefullsize());
    navigate(link);
  };
  const groupFunctions = Helper.handleGroupFunctions(
    commonReducer?.functions?.data
  );
  return (
    <div className="my-sidebar">
      <Scrollbars
        autoHide
        autoHeight
        autoHeightMin={"83vh"}
        // autoHeightMax={500}
        renderThumbVertical={() => (
          <div
            style={{
              backgroundColor: "#a5a5a5",
              marginTop: 2,
              borderRadius: 5,
              opacity: 0.4,
              overflowX: "auto",
              marginTop: "8px"
            }}
          />
        )}
        style={{ height: window.innerHeight - 190 }}
        renderThumbHorizontal={() => <div></div>}
      >
        <div className="my-sidebar__menu">
          {!isEmpty(groupFunctions[moduleCode.TRANGCHU]) && (
            <MenuCap1
              className={datasidebar.TC.className}
              ten={datasidebar.TC.name}
              onClick={handleMenuCap1(
                datasidebar.TC.className,
                datasidebar.TC.path
              )}
              onClickToolTip={handleMenuCap1_ToolTip}
              icon={datasidebar.TC.icon}
              openDraw={openDraw}
            />
          )}
          {!isEmpty(groupFunctions[moduleCode.BanDo]) && (
            <MenuCap1
              className={datasidebar.BanDo.className}
              ten={datasidebar.BanDo.name}
              onClick={handleMenuCap1(
                datasidebar.BanDo.className,
                datasidebar.BanDo.path
              )}
              onClickToolTip={handleMenuCap1_ToolTip}
              icon={datasidebar.BanDo.icon}
              openDraw={openDraw}
            />
          )}
          {!isEmpty(groupFunctions[moduleCode.QUANTRIHETHONG]) && (
            <Accordion
              expanded={expanded === datasidebar.QuanTriHeThong.className}
              onChange={handleMenuExpandCap1(
                datasidebar.QuanTriHeThong.className,
                datasidebar.QuanTriHeThong.path
              )}
            >
              <MenuCap1
                groupFunctions={groupFunctions}
                className={datasidebar.QuanTriHeThong.className}
                ten={datasidebar.QuanTriHeThong.name}
                expandIcon={true}
                icon={datasidebar.QuanTriHeThong.icon}
                openDraw={openDraw}
                onClickToolTip={handleMenuCap2_ToolTip}
              />
              {groupFunctions[moduleCode.QUANTRIHETHONG].includes(
                maChucNang.QUANTRIHETHONG_QUANLYNGUOIDUNG
              ) && (
                <MenuCap2
                  className={
                    datasidebar.QuanTriHeThong.QuanLyNguoiDung.className
                  }
                  ten={datasidebar.QuanTriHeThong.QuanLyNguoiDung.name}
                  onClick={handleMenuDetailCap2(
                    datasidebar.QuanTriHeThong.QuanLyNguoiDung.className,
                    datasidebar.QuanTriHeThong.QuanLyNguoiDung.path,
                    datasidebar.QuanTriHeThong.className
                  )}
                />
              )}
              {groupFunctions[moduleCode.QUANTRIHETHONG].includes(
                maChucNang.QUANTRIHETHONG_QUANLYNHOMNGUOIDUNG
              ) && (
                <MenuCap2
                  className={
                    datasidebar.QuanTriHeThong.QuanLyNhomNguoiDung.className
                  }
                  ten={datasidebar.QuanTriHeThong.QuanLyNhomNguoiDung.name}
                  onClick={handleMenuDetailCap2(
                    datasidebar.QuanTriHeThong.QuanLyNhomNguoiDung.className,
                    datasidebar.QuanTriHeThong.QuanLyNhomNguoiDung.path,
                    datasidebar.QuanTriHeThong.className
                  )}
                />
              )}
              {groupFunctions[moduleCode.QUANTRIHETHONG].includes(
                maChucNang.QUANTRIHETHONG_QUANLYNHOMCHUCNANG
              ) && (
                <MenuCap2
                  className={
                    datasidebar.QuanTriHeThong.QuanLyNhomChucNang.className
                  }
                  ten={datasidebar.QuanTriHeThong.QuanLyNhomChucNang.name}
                  onClick={handleMenuDetailCap2(
                    datasidebar.QuanTriHeThong.QuanLyNhomChucNang.className,
                    datasidebar.QuanTriHeThong.QuanLyNhomChucNang.path,
                    datasidebar.QuanTriHeThong.className
                  )}
                />
              )}
              {groupFunctions[moduleCode.QUANTRIHETHONG].includes(
                maChucNang.QUANTRIHETHONG_QUANLYCHUCNANG
              ) && (
                <MenuCap2
                  className={
                    datasidebar.QuanTriHeThong.QuanLyChucNang.className
                  }
                  ten={datasidebar.QuanTriHeThong.QuanLyChucNang.name}
                  onClick={handleMenuDetailCap2(
                    datasidebar.QuanTriHeThong.QuanLyChucNang.className,
                    datasidebar.QuanTriHeThong.QuanLyChucNang.path,
                    datasidebar.QuanTriHeThong.className
                  )}
                />
              )}
              {groupFunctions[moduleCode.QUANTRIHETHONG].includes(
                maChucNang.QUANTRIHETHONG_PHANQUYENCHUCNANG
              ) && (
                <MenuCap2
                  className={datasidebar.QuanTriHeThong.PhanQuyenChucNang.className}
                  ten={datasidebar.QuanTriHeThong.PhanQuyenChucNang.name}
                  onClick={handleMenuDetailCap2(
                    datasidebar.QuanTriHeThong.PhanQuyenChucNang.className,
                    datasidebar.QuanTriHeThong.PhanQuyenChucNang.path,
                    datasidebar.QuanTriHeThong.className
                  )}
                />
              )}
              {groupFunctions[moduleCode.QUANTRIHETHONG].includes(
                maChucNang.QUANTRIHETHONG_QUANLYSLIDE
              ) && (
                <MenuCap2
                  className={datasidebar.QuanTriHeThong.QuanLySlide.className}
                  ten={datasidebar.QuanTriHeThong.QuanLySlide.name}
                  onClick={handleMenuDetailCap2(
                    datasidebar.QuanTriHeThong.QuanLySlide.className,
                    datasidebar.QuanTriHeThong.QuanLySlide.path,
                    datasidebar.QuanTriHeThong.className
                  )}
                />
              )}
              {groupFunctions[moduleCode.QUANTRIHETHONG].includes(
                maChucNang.QUANTRIHETHONG_QUANLYTINTUC
              ) && (
                <MenuCap2
                  className={datasidebar.QuanTriHeThong.QuanLyTinTuc.className}
                  ten={datasidebar.QuanTriHeThong.QuanLyTinTuc.name}
                  onClick={handleMenuDetailCap2(
                    datasidebar.QuanTriHeThong.QuanLyTinTuc.className,
                    datasidebar.QuanTriHeThong.QuanLyTinTuc.path,
                    datasidebar.QuanTriHeThong.className
                  )}
                />
              )}
              {groupFunctions[moduleCode.QUANTRIHETHONG].includes(
                maChucNang.QUANTRIHETHONG_CAUHINHHIENTHISANPHAM
              ) && (
                <MenuCap2
                  className={
                    datasidebar.QuanTriHeThong.CauHinhHienThiSanPham.className
                  }
                  ten={datasidebar.QuanTriHeThong.CauHinhHienThiSanPham.name}
                  onClick={handleMenuDetailCap2(
                    datasidebar.QuanTriHeThong.CauHinhHienThiSanPham.className,
                    datasidebar.QuanTriHeThong.CauHinhHienThiSanPham.path,
                    datasidebar.QuanTriHeThong.className
                  )}
                />
              )}
            </Accordion>
          )}
          {/* {!isEmpty(groupFunctions[moduleCode.ThongTinDoanhNghiep]) && (
            <MenuCap1
              className={datasidebar.ThongTinDoanhNghiep.className}
              ten={datasidebar.ThongTinDoanhNghiep.name}
              onClick={handleMenuCap1(
                datasidebar.ThongTinDoanhNghiep.className,
                datasidebar.ThongTinDoanhNghiep.path
              )}
              onClickToolTip={handleMenuCap1_ToolTip}
              icon={datasidebar.ThongTinDoanhNghiep.icon}
              openDraw={openDraw}
            />
          )} */}
          {!isEmpty(groupFunctions[moduleCode.THONGTINSANXUAT]) && (
            <Accordion
              expanded={expanded === datasidebar.ThongTinSanXuat.className}
              onChange={handleMenuExpandCap1(
                datasidebar.ThongTinSanXuat.className,
                datasidebar.ThongTinSanXuat.path
              )}
            >
              <MenuCap1
                groupFunctions={groupFunctions}
                className={datasidebar.ThongTinSanXuat.className}
                ten={datasidebar.ThongTinSanXuat.name}
                expandIcon={true}
                icon={datasidebar.ThongTinSanXuat.icon}
                openDraw={openDraw}
                onClickToolTip={handleMenuCap2_ToolTip}
              />
              {groupFunctions[moduleCode.THONGTINSANXUAT].includes(
                maChucNang.THONGTINSANXUAT_COSOSANXUAT
              ) && (
                <MenuCap2
                  className={datasidebar.ThongTinSanXuat.CoSoSanXuat.className}
                  ten={datasidebar.ThongTinSanXuat.CoSoSanXuat.name}
                  onClick={handleMenuDetailCap2(
                    datasidebar.ThongTinSanXuat.CoSoSanXuat.className,
                    datasidebar.ThongTinSanXuat.CoSoSanXuat.path,
                    datasidebar.ThongTinSanXuat.className
                  )}
                />
              )}
              {groupFunctions[moduleCode.THONGTINSANXUAT].includes(
                maChucNang.THONGTINSANXUAT_COSOCHEBIEN
              ) && (
                <MenuCap2
                  className={datasidebar.ThongTinSanXuat.CoSoCheBien.className}
                  ten={datasidebar.ThongTinSanXuat.CoSoCheBien.name}
                  onClick={handleMenuDetailCap2(
                    datasidebar.ThongTinSanXuat.CoSoCheBien.className,
                    datasidebar.ThongTinSanXuat.CoSoCheBien.path,
                    datasidebar.ThongTinSanXuat.className
                  )}
                />
              )}
              {groupFunctions[moduleCode.THONGTINSANXUAT].includes(
                maChucNang.THONGTINSANXUAT_COSOPHANPHOI
              ) && (
                <MenuCap2
                  className={datasidebar.ThongTinSanXuat.CoSoPhanPhoi.className}
                  ten={datasidebar.ThongTinSanXuat.CoSoPhanPhoi.name}
                  onClick={handleMenuDetailCap2(
                    datasidebar.ThongTinSanXuat.CoSoPhanPhoi.className,
                    datasidebar.ThongTinSanXuat.CoSoPhanPhoi.path,
                    datasidebar.ThongTinSanXuat.className
                  )}
                />
              )}
            </Accordion>
          )}
          {!isEmpty(groupFunctions[moduleCode.SanPham]) && (
            <MenuCap1
              className={datasidebar.SanPham.className}
              ten={datasidebar.SanPham.name}
              onClick={handleMenuCap1(
                datasidebar.SanPham.className,
                datasidebar.SanPham.path
              )}
              onClickToolTip={handleMenuCap1_ToolTip}
              icon={datasidebar.SanPham.icon}
              openDraw={openDraw}
            />
          )}
          {!isEmpty(groupFunctions[moduleCode.VungTrong]) && (
            <MenuCap1
              className={datasidebar.VungTrong.className}
              ten={datasidebar.VungTrong.name}
              onClick={handleMenuCap1(
                datasidebar.VungTrong.className,
                datasidebar.VungTrong.path
              )}
              onClickToolTip={handleMenuCap1_ToolTip}
              icon={datasidebar.VungTrong.icon}
              openDraw={openDraw}
            />
          )}
          {!isEmpty(groupFunctions[moduleCode.LoHang]) && (
            <MenuCap1
              className={datasidebar.LoHang.className}
              ten={datasidebar.LoHang.name}
              onClick={handleMenuCap1(
                datasidebar.LoHang.className,
                datasidebar.LoHang.path
              )}
              onClickToolTip={handleMenuCap1_ToolTip}
              icon={datasidebar.LoHang.icon}
              openDraw={openDraw}
            />
          )}
          {/* {!isEmpty(groupFunctions[moduleCode.LichSuSanXuat]) && (
            <MenuCap1
              className={datasidebar.LichSuSanXuat.className}
              ten={datasidebar.LichSuSanXuat.name}
              onClick={handleMenuCap1(
                datasidebar.LichSuSanXuat.className,
                datasidebar.LichSuSanXuat.path
              )}
              onClickToolTip={handleMenuCap1_ToolTip}
              icon={datasidebar.LichSuSanXuat.icon}
              openDraw={openDraw}
            />
          )} */}
          {!isEmpty(groupFunctions[moduleCode.ThongTinLichSuSanXuat]) && (
            <MenuCap1
              className={datasidebar.ThongTinLichSuSanXuat.className}
              ten={datasidebar.ThongTinLichSuSanXuat.name}
              onClick={handleMenuCap1(
                datasidebar.ThongTinLichSuSanXuat.className,
                datasidebar.ThongTinLichSuSanXuat.path
              )}
              onClickToolTip={handleMenuCap1_ToolTip}
              icon={datasidebar.ThongTinLichSuSanXuat.icon}
              openDraw={openDraw}
            />
          )}
          {!isEmpty(groupFunctions[moduleCode.ThongTinLichSuCheBien]) && (
            <MenuCap1
              className={datasidebar.ThongTinLichSuCheBien.className}
              ten={datasidebar.ThongTinLichSuCheBien.name}
              onClick={handleMenuCap1(
                datasidebar.ThongTinLichSuCheBien.className,
                datasidebar.ThongTinLichSuCheBien.path
              )}
              onClickToolTip={handleMenuCap1_ToolTip}
              icon={datasidebar.ThongTinLichSuCheBien.icon}
              openDraw={openDraw}
            />
          )}
          {!isEmpty(groupFunctions[moduleCode.ThongTinLichSuPhanPhoi]) && (
            <MenuCap1
              className={datasidebar.ThongTinLichSuPhanPhoi.className}
              ten={datasidebar.ThongTinLichSuPhanPhoi.name}
              onClick={handleMenuCap1(
                datasidebar.ThongTinLichSuPhanPhoi.className,
                datasidebar.ThongTinLichSuPhanPhoi.path
              )}
              onClickToolTip={handleMenuCap1_ToolTip}
              icon={datasidebar.ThongTinLichSuPhanPhoi.icon}
              openDraw={openDraw}
            />
          )}
          {!isEmpty(groupFunctions[moduleCode.BAOCAOTHONGKE]) && (
            <Accordion
              expanded={expanded === datasidebar.BaoCaoThongKe.className}
              onChange={handleMenuExpandCap1(
                datasidebar.BaoCaoThongKe.className,
                datasidebar.BaoCaoThongKe.path
              )}
            >
              <MenuCap1
                groupFunctions={groupFunctions}
                className={datasidebar.BaoCaoThongKe.className}
                ten={datasidebar.BaoCaoThongKe.name}
                expandIcon={true}
                icon={datasidebar.BaoCaoThongKe.icon}
                openDraw={openDraw}
                onClickToolTip={handleMenuCap2_ToolTip}
              />
              {groupFunctions[moduleCode.BAOCAOTHONGKE].includes(
                maChucNang.BAOCAOTHONGKE_DULIEUTHONGKE
              ) && (
                <MenuCap2
                  className={datasidebar.BaoCaoThongKe.DuLieuThongKe.className}
                  ten={datasidebar.BaoCaoThongKe.DuLieuThongKe.name}
                  onClick={handleMenuDetailCap2(
                    datasidebar.BaoCaoThongKe.DuLieuThongKe.className,
                    datasidebar.BaoCaoThongKe.DuLieuThongKe.path,
                    datasidebar.BaoCaoThongKe.className
                  )}
                />
              )}
              {groupFunctions[moduleCode.BAOCAOTHONGKE].includes(
                maChucNang.BAOCAOTHONGKE_DULIEUKHIHAU
              ) && (
                <MenuCap2
                  className={datasidebar.BaoCaoThongKe.DuLieuKhiHau.className}
                  ten={datasidebar.BaoCaoThongKe.DuLieuKhiHau.name}
                  onClick={handleMenuDetailCap2(
                    datasidebar.BaoCaoThongKe.DuLieuKhiHau.className,
                    datasidebar.BaoCaoThongKe.DuLieuKhiHau.path,
                    datasidebar.BaoCaoThongKe.className
                  )}
                />
              )}
              {groupFunctions[moduleCode.BAOCAOTHONGKE].includes(
                maChucNang.BAOCAOTHONGKE_BAOCAOCHUYENDE
              ) && (
                <MenuCap2
                  className={datasidebar.BaoCaoThongKe.BaoCaoChuyenDe.className}
                  ten={datasidebar.BaoCaoThongKe.BaoCaoChuyenDe.name}
                  onClick={handleMenuDetailCap2(
                    datasidebar.BaoCaoThongKe.BaoCaoChuyenDe.className,
                    datasidebar.BaoCaoThongKe.BaoCaoChuyenDe.path,
                    datasidebar.BaoCaoThongKe.className
                  )}
                />
              )}
            </Accordion>
          )}
          {!isEmpty(groupFunctions[moduleCode.DANHMUC]) && (
            <MenuCap1
              className={datasidebar.DanhMuc.className}
              ten={datasidebar.DanhMuc.name}
              onClick={handleMenuCap1(
                datasidebar.DanhMuc.className,
                datasidebar.DanhMuc.path
              )}
              onClickToolTip={handleMenuCap1_ToolTip}
              icon={datasidebar.DanhMuc.icon}
              openDraw={openDraw}
            />
          )}
          {/* {
            <MenuCap1
              className={datasidebar.NhatKyHeThong.className}
              ten={datasidebar.NhatKyHeThong.name}
              onClick={handleMenuCap1(
                datasidebar.NhatKyHeThong.className,
                datasidebar.NhatKyHeThong.path
              )}
              onClickToolTip={handleMenuCap1_ToolTip}
              icon={datasidebar.NhatKyHeThong.icon}
              openDraw={openDraw}
            />
          } */}
        </div>
      </Scrollbars>
      {/* <div>
                {openDraw === 1 && (
                    <div
                        style={{
                            position: 'absolute',
                            bottom: 10,
                            left: 0,
                            width: 300,
                            color: 'rgba(54, 54, 54, 0.81)',
                            fontWeight: 600,
                            fontSize: 13,
                            textShadow: 'rgb(0 0 0 / 28%) 1px 1px',
                            // fontStyle: 'italic',
                            borderTop: '0.01rem solid rgb(223, 223, 223)',
                            whiteSpace: 'pre-line',
                            paddingLeft: '4px',
                        }}
                    >
                        Được phát triển bởi:
                        <div className="titleLinkForTrungTam" onClick={() => window.open('https://cirensoft.vn/', '_blank', 'noopener,noreferrer')}>
                            Trung tâm Công nghệ phần mềm và Nền tảng số
                        </div>
                    </div>
                )}
            </div> */}
    </div>
  );
}
